import type { IAddress } from "@/types/address";

export const AddressUtils = {
  format(address?: IAddress): string {
    if (!address) {
      return "";
    }

    const parts = [
      address.addressLine1,
      address.addressLine2,
      address.city,
      address.state,
      address.zipCode,
      address.country,
    ];

    return parts
      .map((part) => part?.trim())
      .filter((part) => part && part.length > 0)
      .join(", ");
  },

  getEmpty(): IAddress {
    return {
      name: "",
      googlePlaceId: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      country: "",
      zipCode: "",
      latitude: 0,
      longitude: 0,
    };
  },

  getNormalized(address?: IAddress): IAddress {
    return {
      name: address?.name ?? "",
      googlePlaceId: address?.googlePlaceId ?? "",
      addressLine1: address?.addressLine1 ?? "",
      addressLine2: address?.addressLine2 ?? "",
      city: address?.city ?? "",
      state: address?.state ?? "",
      country: address?.country ?? "",
      zipCode: address?.zipCode ?? "",
      latitude: address?.latitude ?? 0,
      longitude: address?.longitude ?? 0,
    };
  },
};
